import cn from "classnames";

import { CarouselMessage } from "../../aiConversations.types";
import { AssistantAvatar } from "../AssistantAvatar";
import { BubbleMeta } from "../BubbleMeta";

import styles from "./CarouselBubble.module.scss";

interface Props {
  message: CarouselMessage;
  incomingAvatar?: string;
  incomingName?: string;
  onCorrect?: () => void;
}

const IncomingAvatar = ({ name, url }: { name: string; url?: string }) => {
  if (url) {
    return <img className={styles.incomingAvatarImg} src={url} alt={name} />;
  }
  const initials = name
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return <div className={styles.incomingAvatar}>{initials}</div>;
};

const CarouselBubble = ({
  message,
  incomingAvatar,
  incomingName = "?",
  onCorrect
}: Props) => {
  const isOutgoing = message.direction === "outgoing";

  return (
    <div
      className={cn(styles.row, {
        [styles.rowOutgoing]: isOutgoing,
        [styles.rowIncoming]: !isOutgoing
      })}
    >
      {!isOutgoing && <IncomingAvatar name={incomingName} url={incomingAvatar} />}

      <div
        className={cn(styles.bubbleWrapper, {
          [styles.bubbleWrapperOutgoing]: isOutgoing,
          [styles.bubbleWrapperIncoming]: !isOutgoing
        })}
      >
        <div className={styles.cards}>
          {message.cards.map((card) => (
            <div className={styles.card} key={card.id}>
              {card.imageUrl ? (
                <img className={styles.cardImage} src={card.imageUrl} alt="" />
              ) : null}
              <div className={styles.cardBody}>
                <div className={styles.cardName}>{card.name}</div>
                {card.price ? (
                  <div className={styles.cardPrice}>{card.price}</div>
                ) : null}
              </div>
            </div>
          ))}
        </div>
        {message.text ? <div className={styles.caption}>{message.text}</div> : null}
        <BubbleMeta message={message} onCorrect={onCorrect} />
      </div>

      {isOutgoing && <AssistantAvatar letter="A" size={24} />}
    </div>
  );
};

export default CarouselBubble;
